export default __webpack_public_path__ + "static/media/statsImage6 square updated1.37089383.svg";